export const FEATURE_FLAGS = {
  dashboardVariables: false,
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;